import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["source", "otherField"]

  connect() {
    this.updateOtherField()
  }

  updateOtherField() {
    const otherSelected = this.sourceTargets.some((source) => source.dataset.acquisitionSourceOther === "true" && source.checked)
    this.otherFieldTarget.hidden = !otherSelected
    this.otherFieldTarget.querySelector("input").disabled = !otherSelected
  }
}
